module.exports = __webpack_public_path__ + "static/img/kefu.1f73e9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kefu.jpg
// module id = pmdT
// module chunks = 1